import { computed, readonly, ref } from 'vue'
import { type AppError } from '@gat-ship/error-handling'
import {
  StartupState,
  checkStartupStateExists,
  determineAppReady
} from '../model/startup-state-logic'

export function useStartupState() {
  const startupState = ref<StartupState[]>([StartupState.NotStarted])

  const startupStateError = ref<AppError | undefined>()

  function setStartupStateError(error: AppError) {
    startupStateError.value = error
  }

  function setStartupState(state: StartupState) {
    if (checkStartupStateExists(startupState.value, state)) {
      console.error(`Startup state ${state} already set.`)
      return
    }
    startupState.value = [...startupState.value, state]
  }

  /** Returns true if startupState conditions are met. */
  const appReady = computed(() => determineAppReady(startupState.value))

  return {
    startupState,
    startupStateError: readonly(startupStateError),
    setStartupState,
    setStartupStateError,
    appReady
  }
}
